import React from 'react';
import ProductCardFavActions from '@components/molecules/products/product-card-actions/product-card-fav-actions/product-card-fav-actions';
import { ProductCardProps } from '@components/organisms/catalog/components/product-card/product-card-props';
import useRestorePageScrollPosition from '@hooks/use-restore-page-scroll-position';
import ProductCard from './product-card';

export type FavoriteCardProps = Omit<ProductCardProps, 'pageType'> & {
  pageType: 'favourite' | 'profile-favorites';
};

const FavoriteProductCard: React.FC<FavoriteCardProps> = (props) => {
  const { product, pageType, onScrollPositionSet, ...restProps } = props;
  const { setScrollPosition } = useRestorePageScrollPosition({});

  return (
    <ProductCard
      {...restProps}
      product={product}
      pageType={pageType}
      onScrollPositionSet={setScrollPosition}
      renderFooter={<ProductCardFavActions product={product} />}
    />
  );
};

export default FavoriteProductCard;
